// Session types whose teacher can be changed from the CMS.
const TYPES = [
  'YOGA',
  'BACK_PAIN_CONSULT',
  'BACK_PAIN_THERAPY',
  'GROUP_SESSION',
  'WORKSHOP_SESSION'
];

export const can_change_teacher = (type, status) =>
  TYPES.includes(type) && ['SCHEDULED', 'ACTIVE'].includes(status);

// Mid-session replacement ignores the student's opt-out; the backend enforces it only for SCHEDULED.
export const bypass_replacement_opt_out = (status) => status === 'ACTIVE';

export const change_teacher_warning = (status) =>
  status === 'ACTIVE'
    ? "This session is in progress. The new teacher will be notified to join now. If the current teacher is still in the call, ask them to leave; they aren't removed automatically. The student will not be messaged about this change."
    : '';
